import { Box, Button, styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MfaAskSubmitProps } from '../../auth.interface';

interface Props {
  readonly onSubmit: ({ setup }: MfaAskSubmitProps) => Promise<void>;
}

export const MfaAskForm = ({ onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation(['login']);

  return (
    <FormContainer>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          columnGap: '1rem',
          justifyContent: 'space-between',
        }}>
        <Button
          color="primary"
          variant="outlined"
          fullWidth
          onClick={() => onSubmit({ setup: false })}>
          {t('login:form.setUpLater')}
        </Button>
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={() => onSubmit({ setup: true })}>
          {t('login:form.yes')}
        </Button>
      </Box>
    </FormContainer>
  );
};

const FormContainer = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '> div': {
    marginBottom: theme.spacing(3),

    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}));
